import React from "react";
import line from "../BuildingSoftwareSection/BuildingSoftwareImages/line.png";
import LeftSide from "./LeftSide";
import RightSide from "./RightSide";
import people from "../BuildingSoftwareSection/BuildingSoftwareImages/people.png";
import people1 from "../BuildingSoftwareSection/BuildingSoftwareImages/people1.png";
import people2 from "../BuildingSoftwareSection/BuildingSoftwareImages/people2.png";
import Person1 from "../BuildingSoftwareSection/BuildingSoftwareImages/person1.png";
import Person2 from "../BuildingSoftwareSection/BuildingSoftwareImages/person2.png";
import Person3 from "../BuildingSoftwareSection/BuildingSoftwareImages/person3.png";
import yellowEclipse from "../BuildingSoftwareSection/BuildingSoftwareImages/EllipseYellow.png";
import PinkEclipse from "../BuildingSoftwareSection/BuildingSoftwareImages/pinkEclipse.png";

const BuildingSoftware = () => {
  return (
    <section className="mt-10 sm:mt-16 md:mt-24 lg:mt-32">
      {/* === Section Heading === */}
      <div className="text-center px-4">
        <img
          src={line}
          className="mx-auto pb-4 sm:pb-5 w-28 sm:w-32"
          alt="line"
        />
        <h1 className="text-2xl sm:text-3xl lg:text-4xl leading-snug lg:leading-[55px] text-[#1a202c] font-medium">
          Way of building <br />
          <span className="font-bold">Great Software</span>
        </h1>
      </div>

      {/* === Section 1 === */}
      <div
        className="
          flex flex-col lg:flex-row 
          items-center lg:items-center 
          justify-between 
          px-6 md:px-12 lg:px-[102px] 
          gap-12 md:gap-20 lg:gap-28 
          pt-12 lg:pt-[95px] 
          relative
        "
      >
        <LeftSide person={Person1} />
        <RightSide people={people} />

        <img
          src={PinkEclipse}
          className="hidden lg:block absolute top-[94.5%] left-[70%] w-[28px] -z-10"
          alt="pink-eclipse"
        />
        <img
          src={yellowEclipse}
          className="hidden lg:block absolute top-[70px] left-[52.5%] w-[64px] -z-10"
          alt="yellow-eclipse"
        />
      </div>

      {/* === Section 2 === */}
      <div
        className="
          flex flex-col lg:flex-row-reverse 
          items-center lg:items-center 
          justify-between 
          px-6 md:px-12 lg:px-[102px] 
          gap-12 md:gap-20 lg:gap-32
          pt-12 lg:pt-[95px] 
          relative
        "
      >
        <RightSide people={people1} />
        <LeftSide person={Person2} />

        <img
          src={PinkEclipse}
          className="hidden lg:block absolute top-[15.5%] left-[44.5%] w-[28px] -z-10"
          alt="pink-eclipse"
        />
        <img
          src={yellowEclipse}
          className="hidden lg:block absolute left-[15.5%] w-[64px] top-[91%] -z-10"
          alt="yellow-eclipse"
        />
      </div>

      {/* === Section 3 === */}
      <div
        className="
          flex flex-col lg:flex-row 
          items-center lg:items-center 
          justify-between 
          px-6 md:px-12 lg:px-[102px] 
          gap-12 md:gap-20 lg:gap-28 
          pt-12 lg:pt-[95px] 
          relative
        "
      >
        <LeftSide person={Person3} />
        <RightSide people={people2} />

        <img
          src={PinkEclipse}
          className="hidden lg:block absolute top-[14.3%] left-[74%] w-[38px] -z-10"
          alt="pink-eclipse"
        />
        <img
          src={yellowEclipse}
          className="hidden lg:block absolute left-[53%] w-[44px] top-[92%] -z-10"
          alt="yellow-eclipse"
        />
      </div>
    </section>
  );
};

export default BuildingSoftware;
